import Stats from './components/panels/Stats/Stats.vue'
import Dice from './components/panels/Dice/Dice.vue';
import Features from './components/panels/Features/Features.vue';
import Gear from './components/panels/Gear/Gear.vue';
import Moves from './components/panels/Moves/Moves.vue';
import Notes from './components/panels/Notes/Notes.vue';
import Overview from './components/panels/Overview/Overview.vue';
import State from './components/State.vue';

const routes = [
    { path: '/', component: Overview },
    { path: '/features', component: Features },
    { path: '/stats', component: Stats },
    { path: '/moves', component: Moves },
    { path: '/gear', component: Gear },
    { path: '/notes', component: Notes },
    { path: '/dice', component: Dice },
    { path: '/state', component: State }
];

export default routes;